export default "__VITE_ASSET__DD1jtGN4__"